enum ActionTypes {
    SET_OVERRIDING_CATEGORY = "supportButton/setOverridingCategory"
}

export default ActionTypes;
